module.exports = __webpack_public_path__ + "assets/img/more-btn-47537185.png";